import { ProcedimentoVO } from "./procedimentoVO";
import { CampoSpecificoFascicolazioneVO } from "./campo-specifico-fascicolazioneVO";
import { CampoSpecificoFascicoloVO } from "./campo-specifico-fascicoloVO";
import { TempiConservazioneVO } from "./tempi-conservazioneVO";
import { SettoreVO } from "./settoreVO";
import { StatoAttoEnum } from "../enum/stato-atto-enum";
import { UtenteDTO } from "../dto/utenteDTO";
import { UtenteVO } from "./utenteVO";
import { TipologiaDecretoEnum } from "../enum/tipologia-decreto-enum";

export class FiltroRicercaAttoVO {
  annoAtto: number;
  settore: SettoreVO;
  ricercaSemplice: string;
  oggetto: string;
  stato: StatoAttoEnum | StatoAttoEnum[];
  statoDaEscludere: string;
  dataInserimentoDal: string;
  dataInserimentoAl: string;
  sedutaPrenotata: boolean;
  redattore: UtenteVO;
  responsabile: UtenteVO;
  segnaturaArchivistica: string;
  procedimentiAmministrativiAssociati: ProcedimentoVO[];
  campiSpecifici: CampoSpecificoFascicoloVO[];
  campiSpecificiTipologia: CampoSpecificoFascicolazioneVO[];
  numeroRepertorio: number;
  dataRepertoriazioneDal: string;
  dataRepertoriazioneAl: string;
  tempiConservazione: TempiConservazioneVO;
  tipologiaDecreto: TipologiaDecretoEnum | "" = "";
  limitazioniVisibilita: boolean = true;
  textSearch: string;
  pageNumber: number;
  sort: string;
  direz: string;
  //tipo (digitale/cartaceo, solo se si decide di inserirlo tra i metadati del fascicolo).
}
